module.exports = __webpack_public_path__ + "static/media/HighGuardianOfAether03.2806b35c.jpg";